import { createAction, props } from '@ngrx/store';
import { Result } from './results.reducer';

export const setResults = createAction(
  '[Results] Set',
  props<{ results: Result[] }>()
);

export const loadResults = createAction('[Results] Load');
